export const initialState = {
    currentLanguage: 'de-DE',
    currentLocale: 'de',
    languages: [
        {
            value: 'de-DE',
            locale: 'de',
            label: 'Deutsch'
        },
        {
            value: 'en-US',
            locale: 'en',
            label: 'English'
        }
    ]
};

export default function i18nReducer(state = initialState, action = {type: ''}) {
    switch (action.type) {
        case 'CHANGE_LANGUAGE': {
            return {
                ...state,
                currentLanguage: action.language
            };
        }
    }
    return state;
}
